<template>
  <ion-modal :is-open="is_open"
             @willDismiss="is_open=false">

    <ion-header>
      <ion-toolbar>
        <ion-title>
          {{ $t('widgets.provider_selector.title') }}
        </ion-title>
        <ion-buttons slot="end">
          <ion-button @click="is_open=false">
            {{ $t('global.close') }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-searchbar v-model="provider_search" :placeholder="$t('global.search')"></ion-searchbar>
      <ion-list v-if="!loading&&filtered_providers.length">
        <ion-item v-for="provider in filtered_providers" :key="provider.uuid" :button="true"
                  @click="selectProvider(provider)">
          <ion-avatar slot="start">
            <ion-img :src="provider.profile_picture"></ion-img>
          </ion-avatar>
          <ion-label>
            <h2>{{ provider.name }}</h2>
            <p>
              <span v-if="provider.vat_number?.length>2">
              {{ provider.vat_number }}
              </span>
              <span v-else-if="provider.iban_number?.length>2">
              {{ provider.iban_number }}
              </span>
              <span v-else-if="provider.billing_address?.city&&provider.billing_address?.zip">
              {{ provider.billing_address?.zip }} {{ provider.billing_address?.city }}
              </span>
              <span v-else-if="provider.recipients?.length">
              {{ provider.recipients.map(recipient => recipient.email).join(', ') }}
              </span>
            </p>
          </ion-label>
        </ion-item>

        <ion-item v-if="false" :button="true" @click="edit_provider={}; edit_modal=true">
          <ion-avatar slot="start">
          </ion-avatar>

          <ion-label>
            <h2>
              {{ $t('widgets.provider_selector.new_provider') }}
            </h2>
            <p>
              {{ $t('widgets.provider_selector.new_provider_description') }}
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <div v-else-if="!loading" :class="{
        'ion-padding':true,
        [$style['no-result']]:true
       }">
        <p>
          {{ $t('widgets.provider_selector.no_result') }}</p>
        <ion-button @click="edit_provider={}; edit_modal=true" v-if="false">
          {{ $t('widgets.provider_selector.new_provider') }}
        </ion-button>
      </div>
      <div v-else-if="loading" :class="{
      'ion-padding':true,
      [$style['no-result']]:true
    }">
        <ion-spinner></ion-spinner>
      </div>
    </ion-content>
  </ion-modal>


  <ion-modal :is-open="edit_modal"
             @willDismiss="edit_modal=false">
    <ion-header>
      <ion-toolbar>
        <ion-title>
          {{ $t('widgets.provider_selector.edit.title') }}
        </ion-title>
        <ion-buttons slot="end">
          <ion-button @click="edit_modal=false">
            {{ $t('global.close') }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ProviderForm @done="selectProvider($event);edit_modal=false;"/>
    </ion-content>

  </ion-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonSearchbar,
  IonSpinner,
  IonTitle,
  IonToolbar
} from "@ionic/vue";
import { OrderProvider } from "@/orders";

import ProviderForm from "@/components/forms/models/provider/ProviderForm.vue";

export default defineComponent({
  props: ['active', 'page', 'filter'],
  emits: ['close', 'change'],
  data() {
    return {
      providers: [] as OrderProvider[],
      provider_search: "",
      loading: true,
      edit_modal: false,
      edit_provider: {} as OrderProvider,
    };
  },
  methods: {
    loadProviders() {
      this.loading = true;

      // Filter by equipment UUID if provided
      const url = this.$props.filter?.equipmentUuid
        ? `providers/equipment/${this.$props.filter.equipmentUuid}`
        : "providers";

      this.axios.get(url).then((response) => {
        this.providers = response.data;
        this.loading = false;
      });
    },
    selectProvider(provider: OrderProvider) {
      this.$emit('change', {value: provider});
      this.is_open = false;
    }
  },
  computed: {
    is_open: {
      get() {
        return this.$props.active;
      },
      set(value: boolean) {
        if (!value) {
          this.$emit('close');
        }
      }
    },
    filtered_providers() {
      return this.providers.filter(provider => {
        return provider.name.toLowerCase().includes(this.provider_search.toLowerCase());
      });
    }
  },
  watch: {
    active(value: boolean) {
      if (value) {
        this.loadProviders();
      }
    }
  },
  components: {
    IonAvatar,
    IonContent,
    IonHeader,
    IonImg,
    IonItem,
    IonLabel,
    IonList,
    IonSearchbar, IonModal, IonSpinner, ProviderForm, IonTitle, IonButton, IonButtons, IonToolbar
  }
});
</script>

<style lang="scss" module>
.no-result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 70%;

  > * {
    margin: .5em 0;
  }
}
</style>